module.exports = __webpack_public_path__ + "img/1x1.4c877aa.png";